export default __webpack_public_path__ + "static/media/image.infini-solutions.183931d5.png";